
import { RevButtonBase } from '@ds/components/ButtonBase'

export default {
  components: {
    RevButtonBase,
  },
  props: {
    items: {
      default: () => [],
      type: Array,
    },
  },
  computed: {},
}
